/** Downloads the project's reference file (P14): a hidden staff action beside the lifecycle buttons. */
import { useState } from 'react';
import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '@/api/errors';
import { exportProject } from '@/api/projects';

export function ExportProjectButton({ projectId }: { projectId: string }) {
  const { t } = useTranslation('projects');
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { blob, filename } = await exportProject(projectId);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 0);
      notifications.show({ color: 'forest', message: t('staff.exported') });
    } catch (err) {
      notifications.show({ color: 'red', message: errorMessage(err) });
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="xs" variant="default" loading={busy} onClick={() => void run()}>
      {t('staff.export')}
    </Button>
  );
}
